// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import { colors, btn, card, form, search as searchStyles } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg     = type === 'error' ? colors.dangerLt  : colors.successLt;
  const color  = type === 'error' ? colors.danger     : colors.success;
  const border = type === 'error' ? '#fca5a5'          : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: `1px solid ${border}`, fontSize: 13,
    }}>
      <span style={{ color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

class AddCompetitionExpense extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      status_types: [],
      expense_types: [],
      buddy_search_list: [],
      purposes: [],
      expense_details: {
        competition_id: props.match.params.id,
        purpose: 1,
        item: '',
        quantity: 0,
        size: '',
        amount: 0,
        bill: '',
        status: 1,
        paid_by: '',
        paid_on_date: moment(),
        expense_type: 10,
        mobile_no: '',
      },
      data_uploaded: false,
      data_error: false,
      addExpenseView: false,
      search: false,
      search_loading: false,
      toast: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilebill = this.handleFilebill.bind(this);
    this.getCompetitionExpenseInputs = this.getCompetitionExpenseInputs.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
  }

  componentDidMount() {
    this.getCompetitionExpenseInputs();
    console.log(this.state);
  }

  showToast(message, type = 'error') {
    this.setState({ toast: { message, type } });
  }

  getCompetitionExpenseInputs() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_competition_expense/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ status_types: data.status_types, expense_types: data.expense_types, purposes: data.purposes }); })
      .catch(error => error);
  }

  getSearchList() {
    const term = this.state.expense_details.mobile_no;
    if (!term || String(term).trim().length < 3) {
      this.showToast('Enter at least 3 characters to search');
      return;
    }
    this.setState({ search_loading: true, toast: null });
    const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'search': term });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        if (data.Message) {
          this.setState({ buddy_search_list: [], search: false, search_loading: false });
          this.showToast(data.Message);
          return;
        }
        this.setState({
          buddy_search_list: Array.isArray(data.results) ? data.results : [],
          search: true,
          search_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ buddy_search_list: [], search: false, search_loading: false });
        this.showToast(error && error.message ? error.message : 'Search failed. Please try again.');
      });
  }

  setSearch(name, buddy_id, mobile_no) {
    var new_selected_one = Object.assign({}, this.state.expense_details);
    new_selected_one['paid_by'] = buddy_id;
    new_selected_one['paid_by_name'] = name;
    this.setState({ expense_details: new_selected_one, search: false, buddy_search_list: [] });
  }

  postaddExpense(data, props) {
    console.log(data);
    if(data.purpose == '' || data.item == '' || (data.status == 1 && data.paid_by == '')) {
      this.showToast('Please provide all required fields');
      return;
    }
    const url = `${getLocationOrigin()}/tournament/add_competition_expense/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) { formData.append(name, data[name]); }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then((response) => {
        this.showToast(response.message, 'success');
        setTimeout(() => { this.props.history.goBack(); }, 800);
      })
      .catch(error => {
        console.log(error);
        this.showToast(error && error.message ? error.message : 'Failed to add expense');
      });
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.expense_details);
    new_selected_one[name] = event.target.value;
    this.setState({ expense_details: new_selected_one });
  }

  handleDateChange(date) {
    var new_selected_one = Object.assign({}, this.state.expense_details);
    new_selected_one['paid_on_date'] = date;
    this.setState({ expense_details: new_selected_one });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddExpense(this.state.expense_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  toAddExpense() { this.props.history.goBack(); }

  handleFilebill(selectorFiles) {
    var new_selected_one = Object.assign({}, this.state.expense_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['bill'] = selectorFiles[0];
    this.setState({ expense_details: new_selected_one });
  }

  render() {
    console.log(this.state);
    const { expense_details, search, buddy_search_list, search_loading, toast } = this.state;

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: colors.bg, minHeight: '100vh', padding: '24px 20px', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: 680, margin: '0 auto' }}>
          <div style={{ background: colors.surface, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: `1px solid ${colors.border}` }}>
              <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>Add Competition Expense</h2>
            </div>

            <div style={{ padding: '20px 24px' }}>
              <Toast message={toast && toast.message} type={toast && toast.type} onClose={() => this.setState({ toast: null })} />

              <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                <div style={form.row}>
                  <div style={form.labelWide}>Purpose</div>
                  <select name="purpose" style={form.select} value={this.state.value} onChange={this.handleChange}>
                    {this.state.purposes.map((x, index) => (
                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                    ))}
                  </select>
                </div>

                <div style={form.row}>
                  <div style={form.labelWide}>Item</div>
                  <input type="text" name="item" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={form.row}>
                  <div style={form.labelWide}>Quantity</div>
                  <input type="number" name="quantity" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={form.row}>
                  <div style={form.labelWide}>Size</div>
                  <input type="text" name="size" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={form.row}>
                  <div style={form.labelWide}>Amount</div>
                  <input type="number" name="amount" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={form.row}>
                  <div style={form.labelWide}>Type</div>
                  <select name="type" style={form.select} value={this.state.value} onChange={this.handleChange}>
                    {this.state.expense_types.map((x, index) => (
                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                    ))}
                  </select>
                </div>

                <div style={form.row}>
                  <div style={form.labelWide}>Status</div>
                  <select name="status" style={form.select} value={this.state.value} onChange={this.handleChange}>
                    {this.state.status_types.map((x, index) => (
                      <option key={x[0]} value={x[0]}>{x[1]}</option>
                    ))}
                  </select>
                </div>

                {expense_details.status == 1 && (
                  <div>
                    {/* Selected payer */}
                    {expense_details.paid_by !== '' && (
                      <div style={form.row}>
                        <div style={form.labelWide}>Paid By</div>
                        <div style={{
                          display: 'flex', alignItems: 'center', gap: 10,
                          padding: '8px 12px', border: `1px solid ${colors.border}`,
                          borderRadius: 8, background: colors.bg, flex: 1,
                        }}>
                          <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: colors.text }}>{expense_details.paid_by_name}</span>
                          <button
                            type="button"
                            style={{ ...btn.dangerLt, padding: '3px 8px', fontSize: 11 }}
                            onClick={() => {
                              const updated = Object.assign({}, expense_details);
                              updated.paid_by = '';
                              updated.paid_by_name = '';
                              this.setState({ expense_details: updated });
                            }}
                          >✕</button>
                        </div>
                      </div>
                    )}

                    {/* Payer search */}
                    <div style={form.row}>
                      <div style={form.labelWide}>Search Payer</div>
                      <div style={form.searchWrap}>
                        <input
                          type="text"
                          name="mobile_no"
                          placeholder="Name or mobile (min 3 chars)…"
                          style={form.searchInput}
                          value={expense_details.mobile_no}
                          onChange={this.handleChange}
                          onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), this.getSearchList())}
                        />
                        <button
                          type="button"
                          style={{ ...form.searchBtn, opacity: search_loading ? 0.6 : 1 }}
                          onClick={this.getSearchList}
                          disabled={search_loading}
                        >
                          {search_loading ? '…' : '🔍'}
                        </button>
                      </div>
                    </div>

                    {/* Search results */}
                    {search && (
                      <div style={{ marginBottom: 14, paddingLeft: 212 }}>
                        {buddy_search_list.length ? (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                            {buddy_search_list.map(x => (
                              <button
                                key={x.mobile_no + x.name}
                                type="button"
                                style={{ ...btn.outline, fontSize: 12, padding: '6px 12px' }}
                                onClick={() => this.setSearch(x.name, x.id, x.mobile_no)}
                              >
                                {x.name}: {x.mobile_no}
                              </button>
                            ))}
                          </div>
                        ) : (
                          <div style={searchStyles.notFound}>
                            <span style={searchStyles.notFoundText}>No payer found</span>
                          </div>
                        )}
                      </div>
                    )}

                    <div style={form.row}>
                      <div style={form.labelWide}>Paid on Date</div>
                      <DatePicker name="paid_on_date" selected={expense_details.paid_on_date} onChange={this.handleDateChange} />
                    </div>

                    <div style={form.row}>
                      <div style={form.labelWide}>Upload Bill</div>
                      <input type="file" style={{ ...form.input, padding: '7px 12px' }} name="bill" onChange={(e) => this.handleFilebill(e.target.files)} />
                    </div>
                  </div>
                )}

                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
                  <button type="button" style={btn.cancel} onClick={() => { this.toAddExpense(); }}>Cancel</button>
                  <button type="submit" style={btn.primary}>Submit</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCompetitionExpense;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetitionExpense/index.js